import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { type Subscription } from 'rxjs';

import { rateRefreshSubject } from '../../../fulfillment-planner/rate-refresh-subject';
import { bulkCostReviewSetLoading, costReviewModalOpen } from '../../../store/bulk/cost-review/bulk.cost-review.actions';

type RateRefreshPayload = {
  timestamp?: number;
  fulfillmentPlanId?: string;
  isRefreshingRate?: boolean;
  rateObject?: unknown;
};

export const useHandleUpdateRateShopperWithPromoRecommendation = (
  fulfillmentPlanId: string,
  onRateShopperUpdated: () => void,
  onClearPromoRate: (value: null) => void,
) => {
  const dispatch = useDispatch();
  const rateRef = useRef<Subscription>();

  const handleShippingServiceAddedToRateShopper = useCallback(() => {
    onClearPromoRate(null);
    onRateShopperUpdated();
    dispatch(bulkCostReviewSetLoading(true));
    const now = Date.now();
    rateRef.current = rateRefreshSubject.subscribe((nextRate) => {
      const rate = nextRate as RateRefreshPayload;
      if (!rate?.timestamp || rate.timestamp < now) {
        return;
      }
      if (rate?.fulfillmentPlanId !== fulfillmentPlanId) {
        return;
      }
      if (rate.isRefreshingRate) {
        return;
      }
      if (rate.rateObject) {
        dispatch(costReviewModalOpen([fulfillmentPlanId]));
      }
      rateRef.current?.unsubscribe();
    });
  }, [onClearPromoRate, onRateShopperUpdated, fulfillmentPlanId, dispatch]);

  useEffect(() => {
    return () => {
      rateRef.current?.unsubscribe();
    };
  }, []);

  return { handleShippingServiceAddedToRateShopper };
};
